import http from '@/http';

const MovimentacaoService = {
  async getByProjeto(sqProjetoVar) {
    try {
      const response = await http.get('/api/astec/projetos/movimentacoes/' + sqProjetoVar);
      return response;
    } catch (error) {
      console.error("Erro ao buscar movimentações:", error);
      throw error;
    }
  },

  async buscaRelatorioMovimentacaoPentaho(dadosFiltro, onProgress = null) {
    try {
      const config = onProgress ? {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      } : {};
      const response = await http.post('/api/astec/projetos/movimentacoes', dadosFiltro, {
        ...config,
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar movimentações:", error);
      throw error;
    }
  }
};

export default MovimentacaoService;
